import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import Field from '@/components/fields/Field';
import TextInput from '@/components/fields/TextInput';
import { useIsMidotUser } from '@/hooks/permissions/useIsMidotUser';

const FolderBasicInfoTab: React.FC = () => {
  const { t } = useTranslation('organizations');
  const { isMidotUser } = useIsMidotUser();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        p: 4,
        pt: 0,
        '& .MuiFormControl-root': {
          p: 0
        }
      }}
      gap={3}
    >
      <Field
        label={t('layouts.organizations.create.fields.folderName')}
        component={TextInput}
        name="name"
        withFormControl
        innerProps={{
          markAsRequired: true,
          placeholder: [
            t('layouts.organizations.create.untitled'),
            t('layouts.organizations.create.items.folder')
          ].join(' ')
        }}
      />
      <Box />
      {isMidotUser && (
        <Field
          component={TextInput}
          name="legacyId"
          label={t('layouts.organizations.create.fields.oldPodiumAccountNumber')}
          innerProps={{ numbersOnly: true }}
          withFormControl
          outerSx={{
            gridColumn: 'span 2'
          }}
        />
      )}
    </Box>
  );
};

export default FolderBasicInfoTab;
